module.exports = __webpack_public_path__ + "img/2.e8b20409.svg";